
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/pickup",
      function () {
        return require("private-next-pages/tyres/pickup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/pickup"])
      });
    }
  